import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from '@firebase/app';
import '@firebase/storage';
import { UserService } from '../../services/user.service';
declare var fbq: any;

@Component({
  selector: 'page-complete',
  templateUrl: 'complete.html',
})
export class CompletePage {

  storage;
  profile: any = {
    username: '',
    thumb: '',
  };
  authUser: any;
  usernameResult = null;
  // profilePicture: any;
  profileInfo = '';

  defaultRoutes = [
    'landing',
    'index',
    'login',
    'signup',
    'profile',
    'contact',
    'display',
    'links',
    'l',
    'settings',
    'account',
    'team',
    'plans',
  ]

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
  ) {
    this.userService = new UserService();
    this.storage = firebase.storage().ref();
  }

  async userLoaded(user) {
    if (!user || !user.uid) window.location.href = "/login";
    this.authUser = user;
    let profile = await this.userService.getProfile(user.uid);
    profile = profile || {};
    profile.username = profile.username || '';
    this.profile = profile;
  }

  async updatePicture(event) {
    if (!event || !event.target || !event.target.files) return;
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      this.storage.child(`images/${this.authUser.uid}/profile.png`).put(file).then((snapshot) => {
        this.profile.thumb = snapshot.downloadURL;
        this.userService.updateProfile(this.profile);
      }).catch(error => {
        console.log(error);
      });
    }
  }

  async checkUsername() {
    if (!this.profile.username || this.profile.username.length < 3) {
      this.usernameResult = null;
      return;
    }
    this.usernameResult = await this.userService.getProfileByUsername(this.profile.username);
    if (this.usernameResult && this.usernameResult.$id
    && this.usernameResult.$id === this.authUser.uid) {
      this.usernameResult = null;
    }
  }

  async complete() {
    if (this.profile && this.profile.username) {
      this.profileInfo = 'saving...';
      this.profile.usernameLower = this.profile.username.toLowerCase();
      this.profile.isCompleted = true;
      await this.userService.updateProfile(this.profile);
      fbq('trackSingle', '205991469998512', 'Profile Completed');
      this.profileInfo = 'saved';
      this.goTo('plans');
    }
  }

  goTo(page) {
    switch(page) {
      case 'links':
        this.router.navigate(['/links']);
        break;
      case 'login':
        this.router.navigate(['/login']);
        break;
      case 'verify':
        this.router.navigate(['/signup/verify']);
        break;
      case 'plans':
        this.router.navigate(['/plans']);
        break;
      case 'contact':
        // window.location.href = 'contact';
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/complete/complete.ts